/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Limits_Free_SpacesInputs */



/**
* | output |
* | --- |
* | "Personal only" |
*
* @param {Compare_Limits_Free_SpacesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compare_limits_free_spaces = /** @type {((inputs?: Compare_Limits_Free_SpacesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Limits_Free_SpacesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur persönlich")
	return /** @type {LocalizedString} */ ("Personal only")
});